<mat-button-toggle-group [formControl]="input">
    <mat-button-toggle *ngFor="let opt of options" [value]="opt.value">{{opt.display}}</mat-button-toggle>
</mat-button-toggle-group>